import React from 'react'
import { getInitials, isNumber } from '@mote/helpers'
import styled, { x } from '@xstyled/styled-components'
import { Image } from '../image/image'

const DefaultIcon = () => (
  <x.svg
    viewBox='0 0 128 128'
    width='100%'
    height='100%'
    className='mote-avatar__svg'
  >
    <path
      fill='currentColor'
      d='M103,102.1388 C93.094,111.92 79.3504,118 64.1638,118 C48.8056,118 34.9294,111.768 25,101.7892 L25,95.2 C25,86.8096 31.981,80 40.6,80 L87.4,80 C96.019,80 103,86.8096 103,95.2 L103,102.1388 Z'
    />
    <path
      fill='currentColor'
      d='M63.9961647,24 C51.2938136,24 41,34.2938136 41,46.9961647 C41,59.7061864 51.2938136,70 63.9961647,70 C76.6985159,70 87,59.7061864 87,46.9961647 C87,34.2938136 76.6985159,24 63.9961647,24'
    />
  </x.svg>
)

/**
 * @deprecated
 */
export const Avatar = ({
  className,
  src,
  name,
  icon = <DefaultIcon />,
  iconLabel = 'Avatar',
  alt = 'Avatar',
  size = 80,
  fontSize = 36,
  foregroundColor = 'white',
  backgroundColor = 'sky.base'
}) => {
  const avatarUrl = React.useMemo(() => {
    if (!src) return null

    if (src.includes('googleusercontent.com')) {
      const googleUrl = src.split('=')

      if (googleUrl.length > 1) {
        return `${googleUrl[0]}=s${size}-c`
      } else {
        return `${googleUrl[0]}?size=${size}`
      }
    }

    return `${src}?size=${size}`
  }, [src, size])

  const fallback = name ? (
    <span role='img' aria-label={name} style={{ lineHeight: size }}>
      {getInitials(name)}
    </span>
  ) : (
    React.cloneElement(icon, {
      role: 'img',
      'aria-label': iconLabel
    })
  )

  const normalizedSize = isNumber(size) ? `${size}px` : size

  return (
    <Root
      className={className}
      w={normalizedSize}
      h={normalizedSize}
      fontSize={fontSize}
      color={foregroundColor}
      bg={backgroundColor}
    >
      {!avatarUrl && fallback}
      {avatarUrl && (
        <AvatarImage
          src={avatarUrl}
          fallback={fallback}
          referrerPolicy='no-referrer'
          alt={name ?? alt}
        />
      )}
    </Root>
  )
}

const Root = styled.spanBox`
  text-transform: uppercase;
  text-align: center;
  user-select: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  border-radius: 50%;
  font-weight: 500;
  position: relative;
  z-index: 1;
  outline: transparent solid 2px !important;
  outline-offset: 2px;
  overflow: hidden;
`

const AvatarImage = styled(Image)`
  height: 100%;
  width: 100%;
  border-radius: 50%;
  outline: transparent solid 2px !important;
  outline-offset: 2px;
`
